import { render, staticRenderFns } from "./PraticeExplanatoryTopicsDomSection.vue?vue&type=template&id=06a7d325"
import script from "./PraticeExplanatoryTopicsDomSection.vue?vue&type=script&lang=ts"
export * from "./PraticeExplanatoryTopicsDomSection.vue?vue&type=script&lang=ts"
import style0 from "./PraticeExplanatoryTopicsDomSection.vue?vue&type=style&index=0&id=06a7d325&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports